import { Input, notification } from 'antd';
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';

const { TextArea } = Input;

const Urlbox = ({ code, status, rows = 2 }) => {
    const { i18n } = useTranslation();
    let lang = i18n.language;

    return (
        <div className="relative flex items-center">
            <TextArea
                style={{ resize: 'none' }}
                className="pt-4 pr-8"
                readOnly
                value={
                    status === 'Draft'
                        ? lang === 'th'
                            ? 'กรุณาเผยแพร่ก่อนจึงจะนำไปใช้งานได้'
                            : 'Please publish it before it can be used.'
                        : code
                }
                disabled={status === 'Draft'}
                rows={rows}
            />
            <div className="absolute right-4 top-4">
                <CopyToClipboard
                    hidden={status === 'Draft'}
                    onCopy={() => {
                        notification['success']({
                            message: 'Copy to clipboard',
                            // description: 'Copy to clipboard',
                        });
                    }}
                    text={code}
                    className="cursor-pointer hover:opacity-80"
                >
                    <svg
                        width={23}
                        height={23}
                        viewBox="0 0 23 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M5.75 5.87219V15.0938C5.74986 16.0062 6.09677 16.8845 6.72037 17.5505C7.34397 18.2165 8.19756 18.6205 9.108 18.6803L9.34375 18.6875H15.6889C15.5403 19.1078 15.265 19.4718 14.901 19.7292C14.537 19.9867 14.1021 20.1249 13.6562 20.125H8.625C7.48125 20.125 6.38435 19.6706 5.5756 18.8619C4.76685 18.0531 4.3125 16.9562 4.3125 15.8125V7.90625C4.31227 7.46016 4.4504 7.02497 4.70785 6.66067C4.96531 6.29637 5.32942 6.02089 5.75 5.87219ZM16.5312 2.875C17.1031 2.875 17.6516 3.10218 18.0559 3.50655C18.4603 3.91093 18.6875 4.45938 18.6875 5.03125V15.0938C18.6875 15.6656 18.4603 16.2141 18.0559 16.6184C17.6516 17.0228 17.1031 17.25 16.5312 17.25H9.34375C8.77188 17.25 8.22343 17.0228 7.81905 16.6184C7.41468 16.2141 7.1875 15.6656 7.1875 15.0938V5.03125C7.1875 4.45938 7.41468 3.91093 7.81905 3.50655C8.22343 3.10218 8.77188 2.875 9.34375 2.875H16.5312Z"
                            fill="#7B67FB"
                        />
                    </svg>
                </CopyToClipboard>
            </div>
        </div>
    );
};

export default Urlbox;
